import { paymentApi } from "../Api";
import { UsePaymentProps } from "../../../models/stripe/IStripePayment";

export const StripeApi = () => {
    const paymentIntent = async (data: UsePaymentProps) => {
        const headers = {
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PAYMENT_SUBSCRIPTION_KEY,
            'Content-Type': 'application/json'
        };
        return await paymentApi.post('/stripe/payment-intent', data, { headers: headers });
    }
    return { paymentIntent }
}
